var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VODbutton clickable",class:_vm.active?'active':'inactive',on:{"click":function($event){return _vm.$emit('toggle', !_vm.active);}}},[_c('div',{staticClass:"VODimage",class:_vm.active?'':'inactiveInverse',style:({backgroundImage: 'url(' + _vm.imageUrl + ')'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }